import Vue from 'vue'
import App from './App.vue'
import { router } from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import VueMoment from 'vue-moment';
import VueHtmlToPaper from 'vue-html-to-paper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faEdit,
  faPencilAlt,
  faPen,
  faPenAlt,
  faPenSquare,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faList,
  faListAlt,
  faDesktop,
  faInfoCircle,
  faPrint,
  faRegistered,
  faSearch,
  faUsers,
  faBuilding,
  faAddressCard,
  faPhone,
  faPhoneSquare,
  faTrashAlt,
  faSave,
  faMinus,
  faMinusCircle,
  faMinusSquare,
  faArrowAltCircleDown,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faArrowAltCircleUp,
  faArrowCircleDown,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowCircleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faTree,
  faCog,
  faCogs,
  faTable,
  faObjectGroup,
  faPeopleArrows,
  faAddressBook,
  faSpinner,
  faStar,
  faFile,
  faFileAlt,
  faGift,
  faGifts,
  faAward,
  faFileExcel
} from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faPlus, faPlusCircle, faPlusSquare, faEdit, faPencilAlt,
         faPen, faPenAlt, faPenSquare, faCheck, faCheckCircle, faCheckDouble, faCheckSquare, faList, faListAlt, faDesktop,
         faInfoCircle, faPrint, faRegistered, faSearch, faUsers, faBuilding, faAddressCard, faPhone, faPhoneSquare, faTrashAlt,
         faSave, faMinus, faMinusCircle,faMinusSquare, faArrowAltCircleDown, faArrowAltCircleLeft, faArrowAltCircleRight,
         faArrowAltCircleUp, faArrowCircleDown, faArrowCircleLeft, faArrowCircleRight, faArrowCircleUp, faArrowDown,
         faArrowLeft, faArrowRight, faArrowUp, faTree, faCog, faCogs, faTable, faObjectGroup, faPeopleArrows, faAddressBook, faSpinner, faStar, faFile, faFileAlt, faGift, faGifts, faAward, faFileExcel);

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);

Vue.use(BootstrapVue);

Vue.use(VueMoment);

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    './landscape.css'
  ]
}

Vue.use(VueHtmlToPaper, options);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
